import styled from "styled-components";
import { textTheme, colorTheme } from "../../theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LabelContainer = styled.div`
  position: absolute;
  padding-top: 5px;
  bottom: -20;
  right: 0;
  display: flex;
  justify-content: space-between;
  width: 147px;
`;

export const Label = styled.span`
  ${textTheme.small};
  color: ${colorTheme.grayDark};
`;

export const ChartContainer = styled.div`
  position: relative;
  width: 260px;
`;

export const Title = styled.div`
  width: 260px;
  ${textTheme.h6};
  color: ${colorTheme.black};
  padding-bottom: 5px;
`;
